import { useState } from "react";
import * as yup from "yup";
import { FashCreativesController } from "../../../../controllers";
import constant from "../../../../utils/constant";
import { MimaToastUtil } from "../../../../components";

const useAddTheme = (closeModal) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      name: yup.string().required("Name is required"),
      description: yup.string().required("Description is required"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      name: values.name.toUpperCase(),
      description: values.description,
    };

    const { status, errorMessage } =
      await FashCreativesController.createNewTheme(payload);

    if (status === constant.Success) {
      MimaToastUtil.success({ message: status });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };
  return { loading, onSubmit, validationSchema };
};

export default useAddTheme;
